import { gql } from '@apollo/client';

const SUMMARY_FIELDS = `
  summary {
    created
    rowsWritten
    rowsRemoved
    warnings
  }
`;

export const PROMOTE_EXPORT_PROFILE_MUTATION = gql`
  mutation promoteExportProfile($target: ExportProfileTargetInputType!, $document: ExportProfileDocumentInputType!) {
    promoteExportProfile(target: $target, document: $document) {
      ${SUMMARY_FIELDS}
      profile {
        _id
        siteId
        exportType
        sheetWriterClass
        dateFormat
        splitSheetsBySupplierSite
        listName
        multilineHeaders {
          _id
          label
          linkToStorefront
          merges
          headerType
          order
          headerStyles {
            color
          }
          columnStyles {
            color
          }
        }
      }
    }
  }
`;

export const PROMOTE_IMPORT_PROFILE_MUTATION = gql`
  mutation promoteImportProfile($target: ImportProfileTargetInputType!, $document: ImportProfileDocumentInputType!) {
    promoteImportProfile(target: $target, document: $document) {
      ${SUMMARY_FIELDS}
      profile {
        _id
        siteId
        importType
        importName
        delimiter
        useRootSiteForItems
        headerNames
        dateFormats
        validated
        bypassItemValidation
        importErrors
      }
    }
  }
`;

export const PROMOTE_DATA_TABLE_PROFILE_MUTATION = gql`
  mutation promoteDataTableProfile($target: DataTableProfileTargetInputType!, $document: DataTableProfileDocumentInputType!) {
    promoteDataTableProfile(target: $target, document: $document) {
      ${SUMMARY_FIELDS}
      profile {
        id
        siteId
        siteName
        dataTableName
        dataTableType
      }
    }
  }
`;
